import envVar from '../config/envVars';
import httpClient from './httpClient';

const doLogin = async (email: string, isAdminLogin = false) =>
  httpClient.post(`${envVar.REACT_APP_BASE_API_URL}/login`, {
    email,
    isAdminLogin
  });

const authenticate = async (token: string) =>
  httpClient.post(`${envVar.REACT_APP_BASE_API_URL}/authenticate`, {
    token
  });

const authenticateOtp = async (email: string, otp: number) =>
  httpClient.post(`${envVar.REACT_APP_BASE_API_URL}/authenticate`, {
    email,
    otp
  });

const doChildLogin = async (childUserId: string) =>
  httpClient.post(`${envVar.REACT_APP_BASE_API_URL}/login/child`, {
    childUserId
  });

const easypayLogin = async (email: string) =>
  httpClient.post(`${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/login`, {
    email
  });

const loginAPi = {
  doLogin,
  authenticate,
  doChildLogin,
  authenticateOtp,
  easypayLogin
};

export default loginAPi;
